import { FC } from 'react';

export type AnimatronAddressProps = {
    contactEmail: string;
};

const AnimatronAddress: FC<AnimatronAddressProps> = ({ contactEmail }) => (
  <address>
    <a href="//www.animatron.com/">www.animatron.com</a>

    <p>
      221 Crescent Street, Suite 401<br /> Waltham, MA 02453
    </p>
    <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
  </address>
);

export default AnimatronAddress;
